import React, { useState, useEffect } from 'react';

 import { 
  Shield, 
  Network, 
  Globe, 
  Code, 
  FileCode, 
  CheckCircle2, 
  ArrowRight,
  Clock,
  Users,
  Award,
  Zap,
  Settings,
  HeadphonesIcon,
  ChevronDown,
  ChevronUp,
       Cpu,
       Server,
        
} from 'lucide-react';

 import QuoteModal from '../ModalOrcamento';

import Header from "../Header";
import Footer from "../Footer";
import api from '../api/Api';

export default function ServicesPage({ isDarkMode, setIsDarkMode }) {
  const [expandedService, setExpandedService] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');
const [services, setServices] = useState([]);
const [loading, setLoading] = useState(true);
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
const [preSelectedService, setPreSelectedService] = useState(null);


useEffect(() => {
  document.title = "Serviços";
  fetchServico();
}, []);

      const iconMap = {
  'Shield': Shield,
  'Network': Network,
  'Globe': Globe,
  'Code': Code,
  'FileCode': FileCode,
  'Server': Server,
  'Cpu': Cpu
};
const getIcon = (iconName) => {
  return iconMap[iconName] || Shield;
};


const fetchServico = async () => {
  setLoading(true);
  try {
    const response = await api.ListServico();

    const dados = Array.isArray(response) ? response : [];

    const formatado = dados.map(item => ({
      id: item.id,
      icon: getIcon(item.icon),
      title: item.titulo,
      category: item.categoria?.toLowerCase() || 'software',
      shortDescription: item.subtitulo,
      fullDescription: item.descricao,
      color: "from-blue-500 to-purple-600",

      features: item.funcionalidades?.map(f => f.descricao) || [],
      benefits: item.beneficios?.map(b => b.descricao) || [],
      process: item.processos?.map(p => p.descricao) || []
    }));

    setServices(formatado);

  } catch (error) {
    console.error("Erro ao carregar serviços:", error);
  } finally {
    setLoading(false);
  }
};

 

const categories = [
  { id: 'all', name: 'Todos os Serviços', count: services.length },
  { id: 'segurança', name: 'Segurança', count: services.filter(s => s.category === 'segurança').length },
  { id: 'infraestrutura', name: 'Infraestrutura', count: services.filter(s => s.category === 'infraestrutura').length },
  { id: 'software', name: 'Software', count: services.filter(s => s.category === 'software').length },
  { id: 'consultoria', name: 'Consultoria', count: services.filter(s => s.category === 'consultoria').length }
];

  const filteredServices = selectedCategory === 'all' 
    ? services 
    : services.filter(s => s.category === selectedCategory);

  const whyChooseUs = [
{
  icon: Award,
  title: "Clientes Satisfeitos",
  description: "Centenas de clientes confiam na AngoNet, com alto índice de satisfação e relações de parceria duradouras."
},
    {
      icon: Users,
      title: "Equipa Qualificada",
      description: "Técnicos certificados e em constante formação nas últimas tecnologias"
    },
    {
      icon: Clock,
      title: "Suporte 24/7",
      description: "Assistência técnica disponível sempre que precisar, dia e noite"
    },
    {
      icon: Zap,
      title: "Implementação Rápida",
      description: "Projectos entregues no prazo com mínima interrupção das suas operações"
    }
  ];

  const methodologySteps = [
    {
      number: "01",
      title: "Análise",
      description: "Compreendemos profundamente as suas necessidades e desafios"
    },
    {
      number: "02",
      title: "Planeamento",
      description: "Criamos uma estratégia detalhada e cronograma realista"
    },
    {
      number: "03",
      title: "Execução",
      description: "Implementamos a solução com excelência técnica"
    },
    {
      number: "04",
      title: "Suporte",
      description: "Garantimos suporte contínuo e otimização constante"
    }
  ];


  if (loading) {
  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Background igual ao resto da página */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      <div className="flex flex-col items-center justify-center py-40 relative z-10">
        <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-blue-600 mb-6"></div>
        
        <p className={`text-lg font-medium ${
          isDarkMode ? 'text-gray-400' : 'text-gray-600'
        }`}>
          Carregando serviços...
        </p>
      </div>

      <Footer isDarkMode={isDarkMode} />
    </div>
  );
}








  return (
   <div className={`relative min-h-screen transition-colors duration-300 ${
  isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
}`}>

              {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-[100px] animate-pulse ${
          isDarkMode ? 'bg-cyan-500/5' : 'bg-cyan-400/15'
        }`} style={{animationDelay: '2s'}}></div>
        
        {/* Floating particles */}
        <div className="absolute top-[20%] left-[15%] w-1 h-1 bg-blue-500 rounded-full animate-float"></div>
        <div className="absolute top-[40%] right-[20%] w-1.5 h-1.5 bg-cyan-500 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-[60%] left-[30%] w-1 h-1 bg-purple-500 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[80%] right-[40%] w-2 h-2 bg-blue-400 rounded-full animate-float" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-[30%] right-[10%] w-1 h-1 bg-cyan-400 rounded-full animate-float" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-[70%] left-[50%] w-1.5 h-1.5 bg-purple-400 rounded-full animate-float" style={{animationDelay: '2.5s'}}></div>
      </div>
             <Header 
          isDarkMode={isDarkMode} 
          setIsDarkMode={setIsDarkMode} 
        />
      {/* Hero Section */}
      <section className={`relative z-10 py-20 px-6 overflow-hidden ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className={`text-4xl md:text-6xl font-bold mb-6 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Nossos <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Serviços</span>
            </h1>
            <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Soluções tecnológicas completas para transformar o seu negócio. 
              Da segurança à inovação, estamos aqui para impulsionar o seu sucesso.
            </p>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"></div>
      </section>

      {/* Category Filter */}
      <section className={`relative z-10 border-b backdrop-blur-lg ${
        isDarkMode 
          ? 'bg-gray-900/90 border-white/10' 
          : 'bg-white/90 border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                    : isDarkMode
                    ? 'bg-white/5 text-gray-400 hover:bg-white/10'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {category.name}
                <span className="ml-2 text-sm opacity-75">({category.count})</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="relative z-10 py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="space-y-8">
            {filteredServices.map((service, index) => {
              const Icon = service.icon;
              const isExpanded = expandedService === service.id;

              return (
                <div
                  key={service.id}
                  className={`rounded-2xl overflow-hidden transition-all duration-300 ${
                    isDarkMode
                      ? 'bg-gray-800 border border-white/10'
                      : 'bg-white border border-gray-200 shadow-lg'
                  }`}
                  style={{
                    animationDelay: `${index * 0.1}s`
                  }}
                >
                  {/* Service Header */}
                  <div className="p-8">
                    <div className="flex items-start justify-between">
                      <div className="flex items-start space-x-6 flex-1">
                        <div className={`flex-shrink-0 p-4 bg-gradient-to-r ${service.color} rounded-xl`}>
                          <Icon size={32} className="text-white" />
                        </div>
                        
                        <div className="flex-1">
                          <h3 className={`text-2xl md:text-3xl font-bold mb-3 ${
                            isDarkMode ? 'text-white' : 'text-gray-900'
                          }`}>
                            {service.title}
                          </h3>
                          <p className={`text-lg mb-4 ${
                            isDarkMode ? 'text-gray-400' : 'text-gray-600'
                          }`}>
                            {service.shortDescription}
                          </p>
                          <p className={`mb-6 ${
                            isDarkMode ? 'text-gray-500' : 'text-gray-500'
                          }`}>
                            {service.fullDescription}
                          </p>
                          
                          <button
                            onClick={() => setExpandedService(isExpanded ? null : service.id)}
                            className="flex items-center space-x-2 text-blue-600 hover:text-purple-600 font-semibold transition-colors"
                          >
                            <span>{isExpanded ? 'Ver menos' : 'Ver detalhes'}</span>
                            {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                          </button>
                        </div>
                      </div>

                      <button 
                         onClick={() => setIsQuoteModalOpen(true)}
                      className="hidden md:block px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-xl hover:shadow-blue-500/30 transition-all flex-shrink-0 ml-6">
                        Solicitar Orçamento
                      </button>
                    </div>
                  </div>

                  {/* Expanded Content */}
                  {isExpanded && (
                    <div className={`border-t px-8 py-8 ${
                      isDarkMode ? 'border-white/10 bg-gray-900/50' : 'border-gray-200 bg-gray-50'
                    }`}>
                      <div className="grid md:grid-cols-3 gap-8">
                        {/* Features */}
                        <div>
                          <h4 className={`text-lg font-bold mb-4 flex items-center ${
                            isDarkMode ? 'text-white' : 'text-gray-900'
                          }`}>
                            <Settings size={20} className="mr-2 text-blue-600" />
                            Funcionalidades
                          </h4>
                          <ul className="space-y-3">
                            {service.features.map((feature, idx) => (
                              <li key={idx} className="flex items-start">
                                <CheckCircle2 size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span className={`text-sm ${
                                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                                }`}>
                                  {feature}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Benefits */}
                        <div>
                          <h4 className={`text-lg font-bold mb-4 flex items-center ${
                            isDarkMode ? 'text-white' : 'text-gray-900'
                          }`}>
                            <Zap size={20} className="mr-2 text-purple-600" />
                            Benefícios
                          </h4>
                          <ul className="space-y-3">
                            {service.benefits.map((benefit, idx) => (
                              <li key={idx} className="flex items-start">
                                <ArrowRight size={18} className="text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span className={`text-sm ${
                                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                                }`}>
                                  {benefit}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Process */}
                        <div>
                          <h4 className={`text-lg font-bold mb-4 flex items-center ${
                            isDarkMode ? 'text-white' : 'text-gray-900'
                          }`}>
                            <HeadphonesIcon size={20} className="mr-2 text-cyan-600" />
                            Processo
                          </h4>
                          <ol className="space-y-3">
                            {service.process.map((step, idx) => (
                              <li key={idx} className="flex items-start">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-white text-xs flex items-center justify-center mr-3 mt-0.5">
                                  {idx + 1}
                                </span>
                                <span className={`text-sm ${
                                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                                }`}>
                                  {step}
                                </span>
                              </li>
                            ))}
                          </ol>
                        </div>
                      </div>

                      {/* Mobile CTA */}
                      <div className="md:hidden mt-8">
                        <button 
                           onClick={() => setIsQuoteModalOpen(true)}
                        className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-xl transition-all">
                          Solicitar Orçamento
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className={`relative z-10 py-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className={`text-3xl md:text-5xl font-bold mb-4 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Por que Escolher a <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">AngoNet?</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyChooseUs.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className={`text-center p-6 rounded-xl transition-all duration-300 ${
                    isDarkMode
                      ? 'bg-gray-900 hover:bg-gray-900/80'
                      : 'bg-white hover:shadow-xl'
                  }`}
                >
                  <div className="inline-flex p-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl mb-4">
                    <Icon size={32} className="text-white" />
                  </div>
                  <h3 className={`text-xl font-bold mb-3 ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}>
                    {item.title}
                  </h3>
                  <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Methodology */}
      <section className="relative z-10 py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className={`text-3xl md:text-5xl font-bold mb-4 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Nossa <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Metodologia</span>
            </h2>
            <p className={`text-lg max-w-2xl mx-auto ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              Um processo estruturado e transparente que garante o sucesso do seu projeto
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {methodologySteps.map((step, index) => (
              <div key={index} className="relative">
                <div className={`text-center p-6 rounded-xl ${
                  isDarkMode ? 'bg-gray-800' : 'bg-white border border-gray-200'
                }`}>
                  <div className="text-6xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
                    {step.number}
                  </div>
                  <h3 className={`text-xl font-bold mb-3 ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}>
                    {step.title}
                  </h3>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    {step.description}
                  </p>
                </div>
                
                {/* Arrow connector */}
                {index < methodologySteps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <ArrowRight className={isDarkMode ? 'text-gray-700' : 'text-gray-300'} size={32} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={`relative z-10 py-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-3xl md:text-5xl font-bold mb-6 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Pronto para Começar?
          </h2>
          <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Entre em contacto connosco e descubra como podemos ajudar o seu negócio a crescer
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
               onClick={() => setIsQuoteModalOpen(true)}
            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all">
              Solicitar Orçamento
            </button>
       
          </div>
        </div>
      </section>
            <Footer isDarkMode={isDarkMode} />
             <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>

              <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        isDarkMode={isDarkMode}
        preSelectedService={preSelectedService}  
      />
    </div>
  );
}